import { Component } from '@angular/core';
import { AuthService } from "../../shared/service/auth.service";


@Component({
  selector: 'app-root',
  templateUrl: './payment.service.html',
  
})

export class PaymentComponent {
  
  paymentHandler:any = null;

  constructor(    public authService: AuthService,
    ) { }

  ngOnInit() {
    this.invokeStripe();
  }
  
  makePayment(amount) {
    const paymentHandler = (<any>window).StripeCheckout.configure({
      key: 'pk_live_51JNMydG2U7avPAtRc9TDYWi5e2ybwuIMpy35zM8Gewcm3Rtte1CE3mYgW8t2yHpmVupVZ4C4Nkd9qinRGEC0rOFG00iqpL0XGy',
      locale: 'auto',
      token: function (stripeToken: any) {
        console.log(stripeToken)
        alert('Stripe token generated!');
      }
    });
  
    paymentHandler.open({
      name: 'Sustainible',
      description: 'Enter details below!',
      amount: amount * 100
    });
  }
  
  invokeStripe() {
    if(!window.document.getElementById('stripe-script')) {
      const script = window.document.createElement("script");
      script.id = "stripe-script";
      script.type = "text/javascript";
      script.src = "https://checkout.stripe.com/checkout.js";
      script.onload = () => {
        this.paymentHandler = (<any>window).StripeCheckout.configure({
          key: 'pk_live_51JNMydG2U7avPAtRc9TDYWi5e2ybwuIMpy35zM8Gewcm3Rtte1CE3mYgW8t2yHpmVupVZ4C4Nkd9qinRGEC0rOFG00iqpL0XGy',
          locale: 'auto',
          token: function (stripeToken: any) {
            alert('Payment has been successful!');
          }
        });
      }
        
      window.document.body.appendChild(script);
    }
  }

}